import React, { useState, useEffect } from "react";

const PARTNER_SIGNUP_URL = "https://afflat3e3.com/trk/lnk/B8B5A0FB-A60E-489E-BF05-5C5135CFB5D7/?o=16346&c=918277&a=710572&k=9B09CB199FB0D25B61692C2AA9F5014F&l=17465&s2=1";

const fadeInStyles = `
  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .animate-fade-in {
    animation: fade-in 0.4s ease-out;
  }
`;

export default function SurveyLanderV1() {
  const [step, setStep] = useState(1);
  const [answers, setAnswers] = useState({
    earn: "",
    payout: "PayPal",
    time: "",
  });
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.textContent = fadeInStyles;
    document.head.appendChild(styleElement);
    return () => document.head.removeChild(styleElement);
  }, []);

  const update = (field) => (e) => {
    setAnswers((s) => ({ ...s, [field]: e.target.value }));
    setValidationError("");
  };

  const next = () => {
    if (step === 1 && !answers.earn) {
      setValidationError("Please select how much you'd like to earn");
      return;
    }
    if (step === 2 && !answers.payout) {
      setValidationError("Please select your preferred payout method");
      return;
    }
    if (step === 3 && !answers.time) {
      setValidationError("Please select how much time you can spare");
      return;
    }

    setValidationError("");
    if (step < 4) setStep(step + 1);
  };

  const progress = Math.min(step * 25, 100);

  const gclid = typeof window !== "undefined"
    ? new URLSearchParams(window.location.search).get("gclid") || ""
    : "";

  const signupUrl = `${PARTNER_SIGNUP_URL}${gclid ? `&gclid=${gclid}` : ""}`;

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 text-gray-900">
      {/* progress bar */}
      <div className="w-full bg-gray-200 h-2 sticky top-0 z-20">
        <div
          className="h-2 bg-emerald-500 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>

      <main className="flex-grow flex items-center justify-center p-4">
        {step === 1 && (
          <StepCard title="Step 1 of 3">
            <p className="text-center mb-2">
              How much would you like to earn per month?
            </p>
            <div className="space-y-2">
              <Radio name="earn" value="$30–$50" checked={answers.earn === "$30–$50"} onChange={update("earn")}>
                $30–$50 per month
              </Radio>
              <Radio name="earn" value="$50–$100" checked={answers.earn === "$50–$100"} onChange={update("earn")}>
                $50–$100 per month
              </Radio>
              <Radio name="earn" value="$100–$200" checked={answers.earn === "$100–$200"} onChange={update("earn")}>
                $100–$200 per month
              </Radio>
              <Radio name="earn" value="$200+" checked={answers.earn === "$200+"} onChange={update("earn")}>
                $200+ per month
              </Radio>
            </div>
            {validationError && <p className="text-red-500 text-sm mt-2">{validationError}</p>}
            <PrimaryButton onClick={next}>Next →</PrimaryButton>
          </StepCard>
        )}

        {step === 2 && (
          <StepCard title="Step 2 of 3">
            <p className="text-center mb-2">How would you like to receive your rewards?</p>
            <div className="space-y-2">
              <Radio
                name="payout"
                value="PayPal"
                checked={answers.payout === "PayPal"}
                onChange={update("payout")}
              >
                PayPal (Instant)
              </Radio>
              <Radio
                name="payout"
                value="Amazon Gift Card"
                checked={answers.payout === "Amazon Gift Card"}
                onChange={update("payout")}
              >
                Amazon Gift Card
              </Radio>
              <Radio
                name="payout"
                value="Check"
                checked={answers.payout === "Check"}
                onChange={update("payout")}
              >
                Check by Mail
              </Radio>
            </div>
            {validationError && <p className="text-red-500 text-sm mt-2">{validationError}</p>}
            <PrimaryButton onClick={next}>Next →</PrimaryButton>
          </StepCard>
        )}

        {step === 3 && (
          <StepCard title="Step 3 of 3">
            <p className="text-center mb-2">
              How much time can you spare for surveys?
            </p>
            <div className="space-y-2">
              <Radio name="time" value="5–10 min" checked={answers.time === "5–10 min"} onChange={update("time")}>
                5–10 minutes per survey
              </Radio>
              <Radio name="time" value="10–15 min" checked={answers.time === "10–15 min"} onChange={update("time")}>
                10–15 minutes per survey
              </Radio>
              <Radio name="time" value="15–20 min" checked={answers.time === "15–20 min"} onChange={update("time")}>
                15–20 minutes per survey
              </Radio>
            </div>
            {validationError && <p className="text-red-500 text-sm mt-2">{validationError}</p>}
            <PrimaryButton onClick={next}>Check Your Eligibility</PrimaryButton>
          </StepCard>
        )}

        {step === 4 && (
          <ResultCard 
            answers={answers} 
            href={signupUrl}
          />
        )}
      </main>
    </div>
  );
}

// Helper Components
const StepCard = ({ title, children }) => (
  <div className="w-full max-w-md bg-white shadow-xl rounded-2xl p-6 space-y-4 animate-fade-in">
    <h2 className="text-xl font-semibold text-center">{title}</h2>
    {children}
  </div>
);

const Radio = ({ children, checked, ...props }) => (
  <label className="flex items-center gap-2 cursor-pointer">
    <input type="radio" className="accent-emerald-600" checked={checked} {...props} />
    {children}
  </label>
);

const PrimaryButton = ({ children, ...props }) => (
  <button
    {...props}
    className="w-full py-3 bg-emerald-600 text-white rounded-lg font-medium shadow hover:bg-emerald-700"
  >
    {children}
  </button>
);

const ResultCard = ({ answers, href }) => (
  <div className="w-full max-w-md bg-white shadow-xl rounded-2xl p-6 space-y-5 animate-fade-in">
    <h2 className="text-2xl font-bold text-center">
      Great news! You're eligible to earn {answers.earn || "$50"} monthly
    </h2>

    <div className="flex items-center justify-center gap-1">
      <svg className="w-5 h-5 fill-emerald-500" viewBox="0 0 20 20">
        <polygon points="10,1 12.472,7.128 19,7.236 13.5,11.764 15.944,18 10,14.27 4.056,18 6.5,11.764 1,7.236 7.528,7.128" />
      </svg>
      <span className="text-sm">4.8/5 rating • 50k+ active members</span>
    </div>

    <ul className="list-disc list-inside space-y-1 text-sm">
      <li>Get $3 instantly for completing your first survey</li>
      <li>Earn $3–$5 per survey via {answers.payout}</li>
      <li>Surveys take just {answers.time || "5–10 minutes"} to complete</li>
      <li>No minimum payout threshold</li>
      <li>Exclusive product testing opportunities</li>
    </ul>

    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full py-4 bg-emerald-600 text-white text-center rounded-lg font-semibold shadow hover:bg-emerald-700 sticky bottom-4"
    >
      Start Earning Now
    </a>

    <p className="text-xs text-gray-500 text-center">
      This site is independent and not endorsed by any survey platform. You will
      complete your registration on their official website.
    </p>
  </div>
); 